'use strict';
/* CARDIX-client voor de Rip Studio mockup (gratis Groq-route).
   Wordt als los script geladen (<script src="cardix-client.js"> vlak voor </body>, door build.py
   van de andere sessie toegevoegd zolang dit bestand bestaat). De mockup zelf is een grote IIFE;
   onderaan die IIFE staat een brug die de interne namen als window-eigenschappen aanbiedt:
   alleen-lezen getters (CDX, I18N, t, tf, $, $$, esc, ic, eur, r2, prodOf, P, LISTED, plate,
   putSafe, addToRip, addAllFromBox, appendMsg, toast, centerOf, clampQ, cleanTxt, setBusy,
   thinking, cdxStatus, clearFollow, followRow, nearBottom, scrollConvo, liveActions, cdxHealth,
   SCRIPTS, openConc, runScript) en getter plus setter voor de vervangbare functies (askChip,
   liveAsk, cdxModeNote, liveProducts, ripBody) en de variabelen RIP en LANG.
   Daarom: nooit een top-level functiedeclaratie met zo'n naam (die vervangt de accessor door een
   gewone eigenschap en dan blijft de mockup intern de oude versie gebruiken). Alles zit in een
   eigen IIFE en wordt aan het einde via gewone toewijzing door de setters gekoppeld.
   Wijzigingen zijn zichtbaar na een refresh; zie cardix-server/CLIENT-EDITS.md. */
(function () {
  if (typeof window.CDX === 'undefined' || typeof window.liveAsk === 'undefined') {
    console.warn('cardix-client: de brug van de mockup ontbreekt, client niet geactiveerd');
    return;
  }

  /* ---------- 1. CDX uitbreiden: gespreks-id, modus, quotum ---------- */
  CDX.mode = CDX.mode || null;
  CDX.quota = CDX.quota || null;
  if (!CDX.cid) { try { CDX.cid = crypto.randomUUID(); } catch (e) { CDX.cid = null; } }

  /* ---------- 2. i18n-sleutels die de mockup nog niet kent ---------- */
  const EXTRA = {
    nl: {
      demoMode: 'Demo-modus (start cardix-server voor echte AI)', liveMode: 'CARDIX live: {0}, {1} producten',
      groqMode: 'CARDIX (Groq, gratis): {0} producten', knoppenMode: 'CARDIX knoppen: kies je budget en franchise', quotaLow: 'nog {0} vrije vragen vandaag',
      swap: 'Vervang', onlyThis: 'Alleen dit', remove: 'Haal weg', qtyLess: 'Eentje minder', qtyMore: 'Eentje meer',
      boxFreed: '{0} vrijgekomen. Pas de box verder aan, of vraag CARDIX om aan te vullen.', boxEmpty: 'Je haalde alles uit de box. Vraag CARDIX gerust een nieuw voorstel.',
      noAlt: 'Geen alternatief in deze prijsklasse op voorraad.', altTitle: 'Vervang door:', toastOne: '{0} toegevoegd aan je rip',
      swapTitle: 'Vervang {0}', swapNow: 'Nu in je box: {0} voor {1}', sameKind: 'Zelfde soort', otherKinds: 'Andere soorten binnen {0}', cheaper: '{0} goedkoper', pricier: '{0} duurder', samePrice: 'Zelfde prijs', closeSheet: 'Sluiten', packsN: '{0} boosters', perPack: '{0} per booster', swapped: '{0} staat nu in je box', tierHow: 'Hoe werkt dit?',
      addTitle: 'Voeg iets toe aan je box', addNow: 'Kies een product uit de voorraad van vandaag; het komt in je box met aantal 1.', searchPh: 'Zoek een product, set of soort', results: 'Resultaten', noResults: 'Niets gevonden. Probeer een andere naam of soort.', otherFranchises: 'Andere franchises', fitsBox: 'Past bij je box: {0}', accessories: 'Accessoires', addSelf: 'Voeg zelf iets toe', added: '{0} toegevoegd aan je box', nProducts: '{0} producten',
    },
    fr: {
      demoMode: 'Mode demo (lance cardix-server pour la vraie IA)', liveMode: 'CARDIX live: {0}, {1} produits',
      groqMode: 'CARDIX (Groq, gratuit): {0} produits', knoppenMode: 'CARDIX boutons: choisis ton budget et ta franchise', quotaLow: 'encore {0} questions libres aujourd\'hui',
      swap: 'Remplacer', onlyThis: 'Juste celui-ci', remove: 'Retirer', qtyLess: 'Un de moins', qtyMore: 'Un de plus',
      boxFreed: '{0} libérés. Ajuste encore la box, ou demande à CARDIX de compléter.', boxEmpty: 'Tu as tout retiré de la box. Demande une nouvelle proposition à CARDIX.',
      noAlt: 'Pas d\'alternative dans cette gamme de prix en stock.', altTitle: 'Remplacer par:', toastOne: '{0} ajouté à ton rip',
      swapTitle: 'Remplacer {0}', swapNow: 'Dans ta box: {0} pour {1}', sameKind: 'Meme type', otherKinds: 'Autres types dans {0}', cheaper: '{0} moins cher', pricier: '{0} plus cher', samePrice: 'Meme prix', closeSheet: 'Fermer', packsN: '{0} boosters', perPack: '{0} par booster', swapped: '{0} est maintenant dans ta box', tierHow: 'Comment ca marche ?',
      addTitle: 'Ajoute quelque chose a ta box', addNow: 'Choisis un produit du stock du jour; il rejoint ta box avec la quantite 1.', searchPh: 'Cherche un produit, une serie ou un type', results: 'Resultats', noResults: 'Rien trouve. Essaie un autre nom ou type.', otherFranchises: 'Autres franchises', fitsBox: 'Va avec ta box: {0}', accessories: 'Accessoires', addSelf: 'Ajouter toi-meme', added: '{0} ajoute a ta box', nProducts: '{0} produits',
    },
    en: {
      demoMode: 'Demo mode (start cardix-server for real AI)', liveMode: 'CARDIX live: {0}, {1} products',
      groqMode: 'CARDIX (Groq, free): {0} products', knoppenMode: 'CARDIX buttons: pick your budget and franchise', quotaLow: '{0} free questions left today',
      swap: 'Swap', onlyThis: 'Just this one', remove: 'Remove', qtyLess: 'One less', qtyMore: 'One more',
      boxFreed: '{0} freed up. Keep adjusting the box, or ask CARDIX to top it up.', boxEmpty: 'You removed everything from the box. Ask CARDIX for a new proposal.',
      noAlt: 'No alternative in this price range in stock.', altTitle: 'Swap for:', toastOne: '{0} added to your rip',
      swapTitle: 'Swap {0}', swapNow: 'In your box now: {0} for {1}', sameKind: 'Same kind', otherKinds: 'Other kinds within {0}', cheaper: '{0} cheaper', pricier: '{0} more', samePrice: 'Same price', closeSheet: 'Close', packsN: '{0} boosters', perPack: '{0} per booster', swapped: '{0} is now in your box', tierHow: 'How does this work?',
      addTitle: 'Add something to your box', addNow: 'Pick a product from today\'s stock; it joins your box with quantity 1.', searchPh: 'Search a product, set or kind', results: 'Results', noResults: 'Nothing found. Try another name or kind.', otherFranchises: 'Other franchises', fitsBox: 'Fits your box: {0}', accessories: 'Accessories', addSelf: 'Add something yourself', added: '{0} added to your box', nProducts: '{0} products',
    },
  };
  Object.keys(EXTRA).forEach(l => {
    I18N[l] = I18N[l] || {};
    Object.keys(EXTRA[l]).forEach(k => { if (I18N[l][k] == null) I18N[l][k] = EXTRA[l][k]; });
  });

  /* ---------- 2b. woordkeuze: "mandje" in plaats van "rip" zit sinds 17u34 in de bronnen van de mockup.
     Enkel de herhaalbestelling blijft hier overschreven: die teksten komen uit de patch van de
     livestream-sessie (9f2cc303) die nog "rip" zegt; weg zodra die patch is bijgewerkt. */
  const COPY = {
    nl: { toastRepeat: 'Je vaste bestelling staat klaar', repeatTag: 'Je vaste bestelling', repeatTitle: 'Je bestelling van 14 sep', repeatAdd: 'Herhaal deze bestelling', repeatL2: 'bestelling' },
    fr: { toastRepeat: 'Ta commande habituelle est prête', repeatTag: 'Ta commande habituelle', repeatTitle: 'Ta commande du 14 sept', repeatAdd: 'Refaire cette commande', repeatL1: 'Ta commande', repeatL2: 'commande' },
    en: { toastRepeat: 'Your usual order is ready', repeatTag: 'Your usual order', repeatTitle: 'Your order from 14 Sep', repeatAdd: 'Repeat this order', repeatL2: 'order' },
  };
  Object.keys(COPY).forEach(l => { I18N[l] = I18N[l] || {}; Object.keys(COPY[l]).forEach(k => { I18N[l][k] = COPY[l][k]; }); });
  // vaste labels die de mockup al vertaald had voor dit script liep: opnieuw toepassen
  function herpasVertalingen() {
    document.querySelectorAll('[data-i18n]').forEach(el => { const v = t(el.getAttribute('data-i18n')); if (typeof v === 'string' && v !== el.getAttribute('data-i18n')) el.textContent = v; });
    document.querySelectorAll('[data-i18n-ph]').forEach(el => { const v = t(el.getAttribute('data-i18n-ph')); if (typeof v === 'string') el.placeholder = v; });
    document.querySelectorAll('[data-i18n-aria]').forEach(el => { const v = t(el.getAttribute('data-i18n-aria')); if (typeof v === 'string') el.setAttribute('aria-label', v); });
    document.querySelectorAll('.rip-empty').forEach(el => {
      const b = el.querySelector('b'); if (b) b.textContent = t('emptyT');
      const tn = Array.from(el.childNodes).find(n => n.nodeType === 3 && n.textContent.trim()); if (tn) tn.textContent = t('emptyP');
    });
  }
  herpasVertalingen();

  /* ---------- 3. chips sturen een vaste intentie mee (0 quotum, werkt ook in knoppenmodus) ---------- */
  const CHIP_INTENT = {
    op60: { soort: 'rip_samenstellen', budget: 60, franchise: 'one_piece' },
    gift: { soort: 'zoeken', franchise: 'pokemon', type: 'etb' },
    c151: { soort: 'zoeken', franchise: 'pokemon', type: 'pack', productVermelding: '151' },
  };
  function chipIntent(key) {
    const c = CHIP_INTENT[key];
    return c ? Object.assign({ taal: LANG, soort: 'onduidelijk', budget: null, franchise: 'onbekend', type: 'onbekend', productVermelding: null, winkelinfoOnderwerp: null }, c) : null;
  }
  function cdxAskChip(key) {
    openConc();
    setTimeout(() => { if (CDX.live) cdxLiveAsk(t(SCRIPTS[key].q), false, chipIntent(key)); else runScript(key); }, 300);
  }

  /* ---------- 4. modusmelding onderaan het paneel ---------- */
  function cdxModeNoteV2() {
    const n = $('#cdxMode'); if (!n) return;
    let s;
    if (!CDX.live) s = t('demoMode');
    else if (CDX.mode === 'knoppen') s = t('knoppenMode');
    else if (CDX.mode === 'groq') s = tf('groqMode', CDX.count);
    else s = tf('liveMode', String(CDX.model || 'AI').slice(0, 40), CDX.count);
    const q = CDX.quota ? Number(CDX.quota.verzoekenOver) : NaN;
    if (CDX.live && Number.isFinite(q) && q < 100) s += ' (' + tf('quotaLow', q) + ')';
    n.textContent = s; n.classList.toggle('live', CDX.live);
  }

  /* ---------- 5. liveAsk: zelfde flow als de mockup, plus conversation_id, intentie en modus ---------- */
  async function cdxLiveAsk(text, retry, intentie) {
    text = String(text || '').slice(0, 500).trim(); if (!text || CDX.busy) return;
    CDX.lastQ = text; clearFollow(); $$('#convo .msg.err').forEach(e => e.classList.add('old'));
    if (!retry) { const me = document.createElement('div'); me.className = 'msg me'; me.textContent = text; appendMsg(me); }
    const lastH = CDX.hist[CDX.hist.length - 1]; if (!(retry && lastH && lastH.role === 'user' && lastH.content === text)) CDX.hist.push({ role: 'user', content: text });
    CDX.hist = CDX.hist.slice(-20);
    const bub = document.createElement('div'); bub.className = 'msg cdx live'; bub.setAttribute('aria-busy', 'true');
    bub.innerHTML = '<span class="typing"><i></i><i></i><i></i></span><span class="typing-note">' + esc(t('cdxThinking')) + '</span>';
    appendMsg(bub); thinking(true); setBusy(true); cdxStatus(t('cdxThinking'));
    const ac = new AbortController(); CDX.ctrl = ac; let raw = '', got = false, gotBox = false, chaseSet = false, chaseSold = [], ended = false, failed = false, idle = 0;
    const kick = () => { clearTimeout(idle); idle = setTimeout(() => { failed = true; ac.abort(); }, 30000); }; kick();
    const fail = msg => { failed = true; ended = true; const target = got ? appendMsg(Object.assign(document.createElement('div'), { className: 'msg cdx err' })) : bub; target.classList.add('err'); putSafe(target, msg || t('chatErr')); };
    const handle = ev => {
      if (!ev || typeof ev.type !== 'string') return;
      if (ev.type === 'text' && typeof ev.delta === 'string') { const pin = nearBottom(); if (!got) { got = true; thinking(false); } raw += ev.delta; putSafe(bub, raw); if (pin) scrollConvo(); }
      else if (ev.type === 'chase' && Array.isArray(ev.cards)) { cdxLiveChase(ev); chaseSet = true; chaseSold = Array.isArray(ev.soldOut) ? ev.soldOut : []; }
      else if (ev.type === 'products' && Array.isArray(ev.items)) { cdxLiveProducts(ev.items, chaseSet ? { upsell: true, soldOut: chaseSold } : null); if (ev.items.length) gotBox = true; chaseSold = []; }
      else if (ev.type === 'actions' && Array.isArray(ev.actions)) liveActions(ev.actions);
      else if (ev.type === 'error') fail(typeof ev.message === 'string' ? ev.message.slice(0, 300) : '');
      else if (ev.type === 'done') {
        ended = true; CDX.usage = ev.usage || null; CDX.mode = ev.mode || CDX.mode; CDX.quota = ev.quota || CDX.quota; cdxModeNoteV2();
        /* set zonder voorraad: enkel uitverkochte producten, toch tonen als rijen met link (eigenaar 6 okt) */
        if (chaseSet && chaseSold.length) { cdxLiveProducts([], { upsell: true, soldOut: chaseSold }); chaseSold = []; }
      }
    };
    try {
      const body = { conversation_id: CDX.cid, messages: CDX.hist, rip: RIP.map(i => ({ id: P[i.pid].h, qty: i.qty })), locale: LANG };
      /* paginacontext van de CARDIX Deck (brug: cdxContext, bouwsessie 2026-10-04): waar de klant is, welk product in beeld
         staat, mandje en live. De server gebruikt enkel ids die in de catalogus bestaan; de tekst gaat nooit naar het model. */
      try { if (typeof cdxContext === 'function') { const cx = cdxContext(); if (cx && typeof cx === 'object') body.context = cx; } } catch (e) {}
      if (!retry && intentie) body.intentie = intentie;
      /* CARDIXAI op Railway (testpagina cardworld.be): token uit window.CW_RS_CARDIX; lokaal is er geen token */
      const hdr = { 'Content-Type': 'application/json', Accept: 'text/event-stream' };
      try { if (window.CW_RS_CARDIX && window.CW_RS_CARDIX.token) hdr['X-Cardix-Token'] = window.CW_RS_CARDIX.token; } catch (e) {}
      const r = await fetch(CDX.base + '/cardix/chat', { method: 'POST', headers: hdr, cache: 'no-store', signal: ac.signal, body: JSON.stringify(body) });
      if (!r.ok || !r.body) throw new Error('http ' + r.status);
      const rd = r.body.getReader(), dec = new TextDecoder(); let buf = '';
      for (;;) {
        const { value, done } = await rd.read(); if (done) break; kick();
        buf += dec.decode(value, { stream: true }); let nl;
        while ((nl = buf.indexOf('\n')) > -1) { const line = buf.slice(0, nl).replace(/\r$/, ''); buf = buf.slice(nl + 1); if (line.slice(0, 5) !== 'data:') continue; try { handle(JSON.parse(line.slice(5).trim())); } catch (e) {} }
      }
      if (buf.slice(0, 5) === 'data:') { try { handle(JSON.parse(buf.slice(5).trim())); } catch (e) {} }
      if (!got && !ended) fail();
    } catch (e) {
      if (ac.signal.aborted && !failed) { if (!got) bub.textContent = t('stopped'); else { const n = document.createElement('span'); n.className = 'stopped'; n.textContent = ' ' + t('stopped'); bub.appendChild(n); } }
      else if (!ended || !got) fail();
    }
    clearTimeout(idle); CDX.ctrl = null; setBusy(false); thinking(false); bub.setAttribute('aria-busy', 'false');
    if (raw) { CDX.hist.push({ role: 'assistant', content: cleanTxt(raw).slice(0, 2000) }); CDX.hist = CDX.hist.slice(-20); }
    cdxStatus(raw ? t('cdxDone') + ': ' + cleanTxt(raw).slice(0, 240) : (failed ? t('chatErr') : t('stopped')));
    /* vervolgknoppen (Goedkoper, Meer packs, Liever One Piece) enkel na een antwoord met een productbox; bij een fout
       enkel Opnieuw proberen (eigenaar 6 okt: na een verzendvraag sloegen die knoppen nergens op) */
    if (failed || !raw) followRow(true, true); else if (gotBox) followRow(false);
  }

  /* ---------- 6. de bewerkbare box: aantal, vervangen, alleen dit, weg; totaal rekent live mee ---------- */
  const BOX_MAX_QTY = 12;
  function boxTotal(state) { return r2(state.reduce((s, x) => s + x.p.price * x.qty, 0)); }

  /* ---------- zoeken en vergelijken in de eigen catalogus (geen model, geen quotum) ---------- */
  const norm = v => String(v || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
  /* zoektermen die klanten gebruiken maar die niet letterlijk in de titel staan */
  function zoekHooi(p) {
    const extra = [];
    if (p.type === 'etb') extra.push('etb elite trainer box');
    if (p.kind === 'Ultra Premium Collection') extra.push('upc premium');
    if (p.kind === 'Booster Box') extra.push('display doos box boite');
    if (p.kind === 'Booster Pack' || p.kind === 'Blister') extra.push('pack packs booster boosters pakje');
    if (p.kind === 'Booster Bundle' || p.kind === 'Double Pack Set') extra.push('bundle bundel set');
    if (p.kind === 'Tin' || p.kind === 'Collectie box') extra.push('tin collectie collection box');
    if (p.type === 'acc') extra.push('accessoire accessoires sleeves toploader toploaders hoesjes binder map');
    return norm(p.t + ' ' + p.kind + ' ' + p.franchise + ' ' + (p.set || '') + ' ' + extra.join(' '));
  }
  function matchesQuery(p, q) {
    const toks = norm(q).split(/\s+/).filter(Boolean); if (!toks.length) return true;
    const hay = zoekHooi(p);
    return toks.every(tk => hay.indexOf(tk) > -1);
  }

  /* kandidaten voor het venster. swap: alles behalve het huidige product en wat al in de box zit,
     in drie groepen (zelfde soort, andere soorten binnen de franchise, andere franchises), dichtste
     prijs eerst. add: alles wat nog niet in de box zit, eerst de franchise die al in de box ligt. */
  function pickerGroups(mode, x, state, q) {
    const used = new Set(state.map(it => it.p.id));
    /* uitverkochte producten (p.av === false, zie inStock in de mockup) komen niet in het kiesvenster (eigenaar 6 okt) */
    const pool = LISTED.filter(p => p.av !== false && !used.has(p.id) && (!x || p.id !== x.p.id));
    if (q && norm(q)) {
      return [{ title: t('results'), list: pool.filter(p => matchesQuery(p, q)).sort((a, b) => a.price - b.price) }];
    }
    if (mode === 'swap' && x) {
      const unit = x.p.price; const isAcc = x.p.type === 'acc';
      const byDelta = (a, b) => Math.abs(a.price - unit) - Math.abs(b.price - unit) || a.price - b.price;
      const sameFr = pool.filter(p => p.frKey === x.p.frKey && (p.type === 'acc') === isAcc);
      const zelfde = sameFr.filter(p => p.type === x.p.type || p.kind === x.p.kind).sort(byDelta);
      const zelfdeIds = new Set(zelfde.map(p => p.id));
      const andere = sameFr.filter(p => !zelfdeIds.has(p.id)).sort(byDelta);
      const rest = pool.filter(p => p.frKey !== x.p.frKey && (p.type === 'acc') === isAcc).sort(byDelta);
      return [
        { title: t('sameKind'), list: zelfde },
        { title: tf('otherKinds', x.p.franchise), list: andere },
        { title: t('otherFranchises'), list: rest },
      ];
    }
    const count = {}; state.forEach(it => { count[it.p.frKey] = (count[it.p.frKey] || 0) + it.qty; });
    const topFr = Object.keys(count).filter(k => k !== 'acc').sort((a, b) => count[b] - count[a])[0] || null;
    const byPrice = (a, b) => a.price - b.price;
    const groups = []; const seen = new Set();
    if (topFr) {
      const l = pool.filter(p => p.frKey === topFr && p.type !== 'acc').sort(byPrice);
      if (l.length) { groups.push({ title: tf('fitsBox', l[0].franchise), list: l }); l.forEach(p => seen.add(p.id)); }
    }
    const frOrder = []; pool.forEach(p => { if (p.type !== 'acc' && !seen.has(p.id) && frOrder.indexOf(p.franchise) < 0) frOrder.push(p.franchise); });
    frOrder.forEach(fr => groups.push({ title: fr, list: pool.filter(p => p.franchise === fr && p.type !== 'acc' && !seen.has(p.id)).sort(byPrice) }));
    const acc = pool.filter(p => p.type === 'acc').sort(byPrice); if (acc.length) groups.push({ title: t('accessories'), list: acc });
    return groups;
  }

  function deltaText(p, unit) {
    const d = r2(p.price - unit);
    if (Math.abs(d) < 0.005) return { cls: 'same', txt: t('samePrice') };
    return d < 0 ? { cls: 'down', txt: tf('cheaper', eur(-d)) } : { cls: 'up', txt: tf('pricier', eur(d)) };
  }

  function altCard(p, unit) {
    const b = document.createElement('button'); b.type = 'button'; b.className = 'cx-alt'; b.dataset.alt = p.id;
    const inside = (p.inside && (p.inside[LANG] || p.inside.nl)) || '';
    const packs = p.pk ? tf('packsN', p.pk) + (p.pk > 1 ? ', ' + tf('perPack', eur(r2(p.price / p.pk))) : '') : '';
    const d = unit != null ? deltaText(p, unit) : null;
    b.innerHTML = plate(p, 240, '(min-width:720px) 220px, 44vw') + '<b></b><span class="pp tab"></span>' + (d ? '<span class="delta ' + d.cls + '"></span>' : '') + '<span class="kind"></span><span class="ins"></span>';
    b.querySelector('b').textContent = p.t;
    b.querySelector('.pp').textContent = eur(p.price);
    if (d) b.querySelector('.delta').textContent = d.txt;
    b.querySelector('.kind').textContent = [p.kind, packs].filter(Boolean).join(', ');
    b.querySelector('.ins').textContent = String(inside).slice(0, 140);
    return b;
  }

  /* de kaarten in de box: aantal, vervangen, een subtiel kruisje rechtsboven */
  function renderBox(box, state) {
    /* eigenaar 6 okt: exact het design van de CARDIX-kaartjes ("Cadeau tot 50 euro"): rij met foto, naam en prijs,
       aantal-kiezer en een paarse vierkante knop (hier: vervangen). "-" bij 1 haalt het product uit de box. */
    const wrap = $('.pc-rows', box); wrap.innerHTML = '';
    state.forEach(x => {
      const c = document.createElement('div'); c.className = 'cdk-mini pc-row' + (x.sold ? ' sold' : ''); c.dataset.pid = x.p.id;
      if (x.sold) {
        /* uitverkocht: foto, naam en prijs met een pil, geen aantal-kiezer; foto en naam openen het product */
        c.innerHTML = '<span class="cdk-mini-ph">' + plate(x.p, 96, '44px') + '</span><span class="tx"><b>' + esc(x.p.t) + '</b><span class="tab">' + eur(x.p.price) + '</span></span><span class="cdk-sold">' + esc((CHASE_TX[LANG] || CHASE_TX.nl).sold) + '</span>';
        wrap.appendChild(c); return;
      }
      c.innerHTML = '<span class="cdk-mini-ph">' + plate(x.p, 96, '44px') + '</span>'
        + '<span class="tx"><b>' + esc(x.p.t) + '</b><span class="tab">' + eur(x.p.price * x.qty) + '</span></span>'
        + '<span class="cdk-qty"><button type="button" data-q="-1" aria-label="' + esc(x.qty > 1 ? t('qtyLess') : t('remove')) + '">' + ic('i-minus') + '</button><output>' + x.qty + '</output><button type="button" data-q="1" aria-label="' + esc(t('qtyMore')) + '">' + ic('i-plus') + '</button></span>'
        + '<button type="button" class="btn btn-primary sm cdk-add" data-swap aria-label="' + esc(t('swap')) + '" title="' + esc(t('swap')) + '">' + ic('i-swap') + '</button>';
      wrap.appendChild(c);
    });
    const koop = state.filter(x => !x.sold), total = boxTotal(koop);
    const all = $('[data-all]', box);
    $('span', all).textContent = t('allIn') + '  ' + eur(total);
    all.disabled = !koop.length; all.hidden = !koop.length;
    const note = $('.pbox-note', box);
    if (!state.length) { note.hidden = false; note.textContent = t('boxEmpty'); }
    else if (box.__orig != null && r2(box.__orig - total) > 0) { note.hidden = false; note.textContent = tf('boxFreed', eur(r2(box.__orig - total))); }
    else note.hidden = true;
  }

  /* het kiesvenster: vervangen of toevoegen, met zoekveld; sluit met het kruisje, de achtergrond of Escape */
  let pickerOpen = null;
  function closePicker() {
    if (!pickerOpen) return;
    document.removeEventListener('keydown', pickerOpen.onKey);
    pickerOpen.bg.remove(); pickerOpen = null;
    document.body.classList.remove('cx-swap-open');
  }
  function openPicker(opts) {
    closePicker();
    const mode = opts.mode, box = opts.box, state = opts.state;
    const x = mode === 'swap' ? state[opts.idx] : null;
    if (mode === 'swap' && !x) return;
    const bg = document.createElement('div'); bg.className = 'cx-swap-bg';
    const panel = document.createElement('div'); panel.className = 'cx-swap'; panel.setAttribute('role', 'dialog'); panel.setAttribute('aria-modal', 'true');
    panel.innerHTML = '<div class="cx-swap-h"><div><b></b><span class="now"></span></div><button type="button" class="cx-swap-x" aria-label="' + esc(t('closeSheet')) + '">' + ic('i-close') + '</button></div>'
      + '<div class="cx-swap-s">' + ic('i-search') + '<input type="search" class="cx-q" autocomplete="off" maxlength="60"><span class="cx-count"></span></div>'
      + '<div class="cx-swap-b"></div>';
    panel.querySelector('b').textContent = mode === 'swap' ? tf('swapTitle', x.p.t) : t('addTitle');
    panel.querySelector('.now').textContent = mode === 'swap' ? tf('swapNow', x.p.t, eur(x.p.price)) : t('addNow');
    const q = panel.querySelector('.cx-q'); q.placeholder = t('searchPh');
    const body = panel.querySelector('.cx-swap-b'); const count = panel.querySelector('.cx-count');
    const render = () => {
      body.innerHTML = ''; let n = 0;
      pickerGroups(mode, x, state, q.value).forEach(g => {
        if (!g.list.length) return; n += g.list.length;
        const h = document.createElement('h4'); h.textContent = g.title; body.appendChild(h);
        const grid = document.createElement('div'); grid.className = 'cx-grid';
        g.list.forEach(p => grid.appendChild(altCard(p, mode === 'swap' ? x.p.price : null)));
        body.appendChild(grid);
      });
      if (!n) { const e = document.createElement('p'); e.className = 'none'; e.textContent = q.value ? t('noResults') : t('noAlt'); body.appendChild(e); }
      count.textContent = n ? tf('nProducts', n) : '';
    };
    q.addEventListener('input', render); render();
    bg.appendChild(panel); document.body.appendChild(bg); document.body.classList.add('cx-swap-open');
    const onKey = e => { if (e.key === 'Escape') closePicker(); };
    document.addEventListener('keydown', onKey);
    pickerOpen = { bg, onKey };
    bg.addEventListener('click', e => {
      if (e.target === bg || e.target.closest('.cx-swap-x')) { closePicker(); return; }
      const alt = e.target.closest('[data-alt]'); if (!alt) return;
      const np = prodOf(alt.dataset.alt); if (!np) return;
      if (mode === 'swap') { x.p = np; x.why = ''; toast(tf('swapped', np.t), 'i-swap'); }
      else { state.push({ p: np, qty: 1, why: '' }); toast(tf('added', np.t), 'i-plus'); }
      renderBox(box, state); closePicker();
    });
    requestAnimationFrame(() => bg.classList.add('on'));
    if (window.innerWidth >= 720) q.focus(); else { const xb = panel.querySelector('.cx-swap-x'); if (xb) xb.focus(); }
  }
  const openSwapSheet = (box, state, idx) => openPicker({ mode: 'swap', box, state, idx });
  const closeSwapSheet = closePicker;

  /* Top chase in de chat (7 okt): kaartje in deck-stijl, zelfde markup als de chase-kaart van CARDIX Deck
     (cardix-deck.js): .cdk-cc-knoppen met data-ck="pdx:<k>" openen de PriceDex-pop-up via de bestaande #conc-handler. */
  const CHASE_TX = {
    nl: { h: 'Top chase', hk: 'PriceDex', note: 'Prijs per losse kaart volgens PriceDex ({d}). Tik op een kaart voor details.', all: 'Alle chase kaarten', box: 'Hiermee open je ze', more: 'Toon de volgende {n}', last: 'Toon de laatste {n}', sold: 'Uitverkocht', lead: 'Op voorraad van deze set', leadSold: 'Van deze set, nu uitverkocht' },
    fr: { h: 'Top chase', hk: 'PriceDex', note: 'Prix par carte selon PriceDex ({d}). Touche une carte pour les détails.', all: 'Toutes les chase cards', box: 'Pour les ouvrir', more: 'Voir les {n} suivantes', last: 'Voir les {n} dernières', sold: 'Épuisé', lead: 'En stock pour cette série', leadSold: 'De cette série, épuisé pour le moment' },
    en: { h: 'Top chase', hk: 'PriceDex', note: 'Price per single card according to PriceDex ({d}). Tap a card for details.', all: 'All chase cards', box: 'Open them with', more: 'Show the next {n}', last: 'Show the last {n}', sold: 'Sold out', lead: 'In stock for this set', leadSold: 'From this set, sold out right now' },
  };
  /* eigenaar 6 okt: altijd 6 kaarten in beeld, een knop laadt er telkens 3 bij (de server stuurt er tot 15) */
  const CHASE_SHOW = 6, CHASE_STEP = 3;
  function cdxLiveChase(ev) {
    const cards = (ev.cards || []).filter(x => x && x.k && x.n).slice(0, 15); if (!cards.length) return;
    const tx = CHASE_TX[LANG] || CHASE_TX.nl, fx = v => (typeof eur === 'function' ? eur(v) : '€' + Number(v).toFixed(2));
    const el = document.createElement('div'); el.className = 'msg cdx cdk-ans tone-purple'; el.dataset.kind = 'chase';
    const body = '<div class="cdk-chase">' + cards.map((x, i) => '<button type="button" class="cdk-cc' + (i >= CHASE_SHOW ? ' hid' : '') + '" data-ck="pdx:' + esc(x.k) + '" aria-label="' + esc(x.n + ', ' + fx(x.pr)) + '"><img src="' + esc(x.im || '') + '" alt="" loading="lazy" decoding="async"><span class="nm">' + esc(x.n) + (x.no ? ' <small>#' + esc(x.no) + '</small>' : '') + '</span><span class="pr tab">~' + fx(x.pr) + '</span></button>').join('') + '</div>'
      + '<p class="cdk-note">' + esc(tx.note.replace('{d}', ev.date || '')) + '</p>';
    const moreBtn = cards.length > CHASE_SHOW ? '<button type="button" class="btn btn-ghost" data-cdx-morechase>' + ic('i-plus') + '<span></span></button>' : '';
    /* kind 'kaart' = kaartzoeker (prijs van een losse kaart), anders de top chase van een set */
    const kop = (ev.kind === 'kaart' ? tx.hk : tx.h) + (ev.title ? ' · ' + ev.title : '');
    const allBtn = ev.productId ? '<button type="button" class="btn btn-ghost" data-cdx-allchase="' + esc(ev.productId) + '">' + ic('i-eye') + '<span>' + esc(tx.all) + '</span></button>' : '';
    el.innerHTML = '<div class="cdk-ans-h"><span class="cdk-ans-ic">' + ic('i-spark') + '</span><b>' + esc(kop) + '</b></div><div class="cdk-ans-b">' + body + '</div>'
      + '<div class="cdk-ans-acts">' + moreBtn + allBtn + '</div>';
    const more = el.querySelector('[data-cdx-morechase]');
    if (more) {
      const lbl = () => {
        const n = el.querySelectorAll('.cdk-cc.hid').length;
        if (!n) { more.remove(); return; }
        const k = Math.min(CHASE_STEP, n);
        more.querySelector('span').textContent = (n > CHASE_STEP ? tx.more : tx.last).replace('{n}', k);
      };
      more.addEventListener('click', () => {
        const pin = nearBottom();
        Array.from(el.querySelectorAll('.cdk-cc.hid')).slice(0, CHASE_STEP).forEach(b => b.classList.remove('hid'));
        lbl(); if (pin) scrollConvo();
      });
      lbl();
    }
    const all = el.querySelector('[data-cdx-allchase]');
    if (all) all.addEventListener('click', () => {
      /* de hele set: de chase-muur op de productpagina (deckPoint via de brug in app.js); lukt dat niet,
         dan alle kaarten hier in de chat uitklappen (nooit meer één losse kaart, eigenaar 6 okt) */
      const pid = all.dataset.cdxAllchase;
      let fn = null; try { fn = typeof deckPoint === 'function' && typeof prodOf === 'function' && prodOf(pid) ? deckPoint : null; } catch (e) { fn = null; }
      if (pid && fn) { fn('chase', pid); return; }
      el.querySelectorAll('.cdk-cc.hid').forEach(b => b.classList.remove('hid'));
      const mb = el.querySelector('[data-cdx-morechase]'); if (mb) mb.remove();
    });
    appendMsg(el);
  }

  function cdxLiveProducts(items, opts) {
    const list = items.map(x => ({ p: prodOf(x && x.id), qty: clampQ(x && x.qty), why: x && x.reason })).filter(x => x.p).slice(0, 9);
    /* uitverkochte producten van de set (opts.soldOut, handles): rij met pil "Uitverkocht", niet in het mandje */
    const sold = (opts && Array.isArray(opts.soldOut) ? opts.soldOut : []).map(id => prodOf(id)).filter(p => p && !list.some(x => x.p.id === p.id)).slice(0, 4);
    if (!list.length && !sold.length) return;
    const state = list.map(x => ({ p: x.p, qty: Math.min(BOX_MAX_QTY, x.qty), why: x.why })).concat(sold.map(p => ({ p, qty: 1, why: '', sold: true })));
    const box = document.createElement('div'); box.className = 'pbox cdk-ans tone-purple';
    box.innerHTML = '<div class="cdk-ans-h"><span class="cdk-ans-ic">' + ic('i-pack') + '</span><b>' + (opts && opts.upsell ? esc((CHASE_TX[LANG] || CHASE_TX.nl).box) : t('yourBox')) + '</b></div>'
      + '<div class="cdk-ans-b"><p class="cdk-lead">' + (opts && opts.upsell ? esc(list.length ? (CHASE_TX[LANG] || CHASE_TX.nl).lead : (CHASE_TX[LANG] || CHASE_TX.nl).leadSold) : t('boxNote')) + ':</p><div class="pc-rows"></div>'
      + '<div class="pbox-add"><button type="button" class="pc-btn add" data-add>' + ic('i-plus') + '<span>' + esc(t('addSelf')) + '</span></button></div>'
      + '<div class="pbox-note" hidden></div></div>'
      + '<div class="cdk-ans-acts pbox-acts"><button class="btn btn-gold" type="button" data-all>' + ic('i-plus') + '<span></span></button></div>';
    box.__orig = boxTotal(state.filter(x => !x.sold));
    renderBox(box, state);
    $('[data-all]', box).onclick = () => { const koop = state.filter(x => !x.sold); if (koop.length) addAllFromBox(box, koop); };
    box.addEventListener('click', e => {
      if (e.target.closest('[data-add]')) { e.stopPropagation(); openPicker({ mode: 'add', box, state }); return; }
      const card = e.target.closest('.pc-row'); if (!card || !box.contains(card)) return;
      const cards = $$('.pc-row', box); const idx = cards.indexOf(card); const x = state[idx]; if (!x) return;
      const q = e.target.closest('[data-q]'), rm = e.target.closest('[data-rm]'), sw = e.target.closest('[data-swap]');
      /* eigenaar 6 okt: tik op de productafbeelding opent het product (openProduct via de brug in app.js) */
      const ph = e.target.closest('.cdk-mini-ph') || (x.sold ? e.target.closest('.tx') : null);
      if (ph && !(q || rm || sw)) { e.stopPropagation(); if (typeof openProduct === 'function') openProduct(x.p.id); return; }
      if (!(q || rm || sw)) return;
      e.stopPropagation();
      if (q) { x.qty = Math.max(0, Math.min(BOX_MAX_QTY, x.qty + Number(q.dataset.q))); if (!x.qty) state.splice(idx, 1); renderBox(box, state); return; }
      if (rm) { state.splice(idx, 1); renderBox(box, state); return; }
      if (sw) openSwapSheet(box, state, idx);
    }, true);
    appendMsg(box);
  }

  /* ---------- 7. totaalkaart: lange bedragen kleiner zetten in plaats van onder de stapel te schuiven ---------- */
  function wrapRipBody() {
    if (typeof ripBody !== 'function') return;
    const ripBodyOrig = ripBody;
    ripBody = function (stackId) {
      const html = ripBodyOrig(stackId);
      if (typeof html !== 'string') return html;
      return html
        .replace(/(<div class="lbl">[\s\S]*?<b class="tab)(">)([^<]*)(<\/b>)/, (m, a, b, bedrag, c) => a + (bedrag.length > 11 ? ' xlong' : bedrag.length > 9 ? ' long' : '') + b + bedrag + c)
;
    };
  }

  /* ---------- 7b. typemachine-placeholder op de invoerbalk, zoals de zoekbalk van cardworld.be ----------
     Zelfde ritme als het live thema (60 ms typen, 30 ms wissen, 2 s pauze na een zin, 0,5 s na het wissen).
     Leeg zodra het veld focus heeft of tekst bevat; statisch bij "minder beweging". */
  (function typewriter() {
    if (window.CW_CARDIX === false) return; /* CARDIX uit (pack.js CARDIX_AAN): geen typemachine in het verborgen paneel */
    const el = document.getElementById('cin2'); if (!el) return;
    const ZINNEN = {
      nl: ['Vertel me je budget en wat je zoekt', '60 euro, Pokémon, voor een cadeau', 'Wat zit er in de Prismatic Evolutions ETB?', 'One Piece onder 100 euro', 'Vanaf hoeveel is verzending gratis?', 'Wat wordt er nu geopend?'],
      fr: ['Dis-moi ton budget et ce que tu cherches', '80 euros, plutot One Piece', 'Qu\'est-ce qu\'il y a dans une ETB ?', 'Vous livrez en France ?', 'Qu\'est-ce qui s\'ouvre en ce moment ?'],
      en: ['Tell me your budget and what you want', '50 euros, Pokemon, for a beginner', 'What is in an Elite Trainer Box?', 'Do you have Lorcana in stock?', 'What is opening right now?'],
    };
    const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) return; // de vaste placeholder van de mockup blijft staan
    const typeSpeed = 60, deleteSpeed = 30, pauseAfterType = 2000, pauseAfterDelete = 500;
    let idx = 0, pos = 0, deleting = false, timer = null, taal = null;
    const lijst = () => ZINNEN[LANG] || ZINNEN.nl;
    const tick = () => {
      if (taal !== LANG) { taal = LANG; idx = 0; pos = 0; deleting = false; }
      if (document.activeElement === el || el.value) { el.placeholder = ''; el.classList.remove('cx-typing'); timer = setTimeout(tick, 300); return; }
      const zinnen = lijst(); const cur = zinnen[idx % zinnen.length];
      el.classList.add('cx-typing');
      if (!deleting) {
        pos++; el.placeholder = cur.substring(0, pos);
        if (pos >= cur.length) { deleting = true; timer = setTimeout(tick, pauseAfterType); return; }
        timer = setTimeout(tick, typeSpeed);
      } else {
        pos--; el.placeholder = cur.substring(0, pos);
        if (pos <= 0) { deleting = false; idx = (idx + 1) % zinnen.length; timer = setTimeout(tick, pauseAfterDelete); return; }
        timer = setTimeout(tick, deleteSpeed);
      }
    };
    el.addEventListener('blur', () => { if (!el.value) { pos = 0; deleting = false; } });
    document.addEventListener('visibilitychange', () => { if (document.hidden) { clearTimeout(timer); } else { clearTimeout(timer); timer = setTimeout(tick, 400); } });
    el.placeholder = '';
    timer = setTimeout(tick, 900);
  })();

  /* ---------- 8. koppelen via de brug: gewone toewijzingen, zodat de setters de interne binding vervangen ---------- */
  /* CARDIX uit (window.CW_CARDIX === false): enkel de mandje-opmaak (wrapRipBody), geen chatfuncties vervangen en geen health-check */
  const cdxUit = window.CW_CARDIX === false;
  try {
    if (!cdxUit) {
      askChip = cdxAskChip;
      liveAsk = cdxLiveAsk;
      cdxModeNote = cdxModeNoteV2;
      liveProducts = cdxLiveProducts;
    }
    wrapRipBody();
  } catch (e) {
    console.warn('cardix-client: koppelen via de brug mislukte', e && e.message);
  }
  window.cardixClient = { versie: '2026-10-04l', chipIntent, pickerGroups, openPicker, closePicker };

  /* ---------- 9. modus en quotum al bij het laden tonen ---------- */
  if (!cdxUit) cdxHealth().then(j => { if (j) { CDX.mode = j.mode || null; CDX.quota = j.quota || null; } cdxModeNoteV2(); });
})();
